import { useEffect, useState } from "react";
import AdminPageLayout from "../components/AdminPageLayout";
import { fetchWebImageCategories, createWebImageCategory, deleteWebImageCategory } from "./adminWebImageService";
import { useToast } from "../../common/toast/ToastContext";

const AdminWebImageCategoriesPage = () => {
  const { showToast } = useToast();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newName, setNewName] = useState("");
  const [saving, setSaving] = useState(false);
  const [rowErrors, setRowErrors] = useState({});

  const load = async () => {
    setLoading(true);
    const res = await fetchWebImageCategories();
    if (res.status === 200) setCategories(res.data || []);
    else showToast("Failed to load categories", "error");
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const handleAdd = async () => {
    const name = newName.trim().toUpperCase();
    if (!name) return;
    setSaving(true);
    const res = await createWebImageCategory(name);
    if (res.status === 200 || res.status === 201) {
      showToast("Category created", "success");
      setNewName("");
      await load();
    } else if (res.status === 409) {
      showToast("Category already exists", "error");
    } else {
      showToast(res.message || "Create failed", "error");
    }
    setSaving(false);
  };

  const handleDelete = async (cat) => {
    setRowErrors((prev) => ({ ...prev, [cat]: "" }));
    const res = await deleteWebImageCategory(cat);
    if (res.status === 200 || res.status === 204) {
      showToast("Category deleted", "success");
      await load();
    } else if (res.status === 400) {
      setRowErrors((prev) => ({ ...prev, [cat]: "Cannot delete — category is in use" }));
    } else if (res.status === 404) {
      showToast("Category not found", "error");
    } else {
      showToast(res.message || "Delete failed", "error");
    }
  };

  return (
    <AdminPageLayout
      title="Web Image Categories"
      subtitle="Manage the categories available for web images."
    >
      <div style={{ display: "flex", gap: 8, marginBottom: "1.5rem", maxWidth: 400 }}>
        <input
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleAdd()}
          placeholder="New category name"
          style={{ flex: 1, padding: "0.45rem 0.75rem", border: "1px solid #d1d5db", borderRadius: 6, fontSize: "0.9rem" }}
        />
        <button className="adm-btn adm-btn-primary" onClick={handleAdd} disabled={saving || !newName.trim()}>
          {saving ? "Adding…" : "Add"}
        </button>
      </div>

      {loading ? (
        <p className="adm-loading">Loading…</p>
      ) : categories.length === 0 ? (
        <p className="adm-empty">No categories yet.</p>
      ) : (
        <div className="ac-table-wrap">
          <table className="ac-table">
            <thead>
              <tr>
                <th>Category Name</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((cat) => (
                <tr key={cat}>
                  <td>
                    <strong>{cat}</strong>
                    {rowErrors[cat] && (
                      <span style={{ marginLeft: 10, color: "#b91c1c", fontSize: "0.82rem" }}>
                        {rowErrors[cat]}
                      </span>
                    )}
                  </td>
                  <td>
                    <button className="adm-btn adm-btn-danger adm-btn-sm" onClick={() => handleDelete(cat)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </AdminPageLayout>
  );
};

export default AdminWebImageCategoriesPage;
